"use client";

import React, { type ReactElement } from "react";

function AnalyseMain(): ReactElement {
  return (
    <div className="relative flex flex-col h-[calc(100vh-56px)] justify-end items-center bg-accent-background p-8 overflow-hidden"></div>
  );
}

export { AnalyseMain };
